import React from 'react';

const AskButton = props => {
  const text = '資料を請求する';

  return (
    <div
      className="AskButtonContainer"
    >
      <a
        className="BoxShadow AskButton"
        href={props.uri}
      >
        {text}
      </a>
    </div>
  );
};


export default AskButton;
